import { ReviewCards } from "@/components/services/EditorialServicePage";

const reviews = [
  {
    quote:
      "The staff and doctors are very professional and they are very knowledgeable about what they do, I would recommend them to anyone who is looking for a professional dentistry specialist.",
    author: "Elain M.",
  },
  {
    quote:
      "The staff was friendly, the office was very, very clean (That’s very important for me) The dentist made me feel comfortable throughout my visit. Everyone was professional and caring. I highly recommend this clinic.",
    author: "Ximena C.",
  },
  {
    quote:
      "Very professional, reasonable prices. Definitely will consider to visit there whenever I needed",
    author: "Russy E.",
  },
];

export default function PatientExperiences() {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 text-center pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2 after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]">
          Patient Experiences
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed text-center">
          Our patients say it best. Read what Astoria locals have experienced
          firsthand with our emergency dental care team at Smile4Me.
        </p>
        <ReviewCards reviews={reviews} />
      </div>
    </section>
  );
}
